// extracted by mini-css-extract-plugin
module.exports = {"container":"RoleSelector_container__2Ogry","roles":"RoleSelector_roles__3Leq1","roleDescription":"RoleSelector_roleDescription__2nruS"};